/** @format */
import { css } from 'styled-components';

import { ConfirmModalProps } from './index';

/**
 * Base styles for the are you sure modal component
 *
 * @param {ConfirmModalProps} props The are you sure modal properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: ConfirmModalProps) => css`
    text-align: center;

    .buttons {
        display: flex;
        justify-content: center;

        button {
            flex: 0 1 50%;

            &:nth-child(1) {
                margin-right: 0.4rem;
            }

            &:nth-child(2) {
                margin-left: 0.4rem;
            }
        }
    }

    p {
        margin: 0 0 var(--layout-spacing-24);
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The are you sure modal component styles
 *
 * @param {ConfirmModalProps} props The are you sure modal properties object
 * */
export const styles = (props: ConfirmModalProps) => css`
    ${baseStyles(props)}
`;
